var React = require('react');

function BlockUser (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8,0C3.6,0,0,3.6,0,8s3.6,8,8,8s8-3.6,8-8S12.4,0,8,0z M8,14.4c-3.5,0-6.4-2.9-6.4-6.4c0-1.5,0.5-2.8,1.4-3.9l9,9\n\tC10.8,13.9,9.5,14.4,8,14.4z M13,11.9l-9-9C5.2,2.1,6.5,1.6,8,1.6c3.5,0,6.4,2.9,6.4,6.4C14.4,9.5,13.9,10.8,13,11.9z","fill":"currentColor"}));
}

BlockUser.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","style":{"enableBackground":"new 0 0 16 16"},"xmlSpace":"preserve"};

module.exports = BlockUser;

BlockUser.default = BlockUser;
